// extracted by mini-css-extract-plugin
export var backdropBlur = "_c9-0";
export var contentCard = "_c9-5";
export var frame = "_c9-2";
export var image = "_c9-4";
export var imagePane = "_c9-3";
export var modal = "_c9-1";